import { render, staticRenderFns } from "./LibraryPermissionsWarning.vue?vue&type=template&id=2d8a2c49"
import script from "./LibraryPermissionsWarning.vue?vue&type=script&lang=js"
export * from "./LibraryPermissionsWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports